export const environment = {
  production: true,
  isMockEnabled: false, // You have to switch this, when your real back-end is done
  authTokenKey: 'authce9d77b308c149d5992a80073637e4d5',
  apiPath: 'https://api-qa.carpentersonline.net',
  adClientId: '01210019-2936-485d-b31c-7109e805b6f5',
  adTenantId: '75c07ee5-285b-4b19-83de-0444cd21824d',
  zoneOverrideGroup: 'override',
};
